import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Tab } from '../../models/Tabs';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnInit {
  @Input() tabs: Tab[] = [];
  @Input() activeTab: string;
  @Output() change = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  changeTab(id) {
    this.change.emit(id);
  }
}
